import { render, staticRenderFns } from "./PlaceholderSuggestionList.vue?vue&type=template&id=74ca5cb5&scoped=true"
import script from "./PlaceholderSuggestionList.vue?vue&type=script&lang=ts"
export * from "./PlaceholderSuggestionList.vue?vue&type=script&lang=ts"
import style0 from "./PlaceholderSuggestionList.vue?vue&type=style&index=0&id=74ca5cb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ca5cb5",
  null
  
)

export default component.exports